export default function EditIcon() {
  return (
    <>
      <svg
        width='22'
        height='23'
        viewBox='0 0 22 23'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M6.41675 6.91699H5.50008C5.01385 6.91699 4.54754 7.11015 4.20372 7.45396C3.8599 7.79778 3.66675 8.2641 3.66675 8.75033V17.0003C3.66675 17.4866 3.8599 17.9529 4.20372 18.2967C4.54754 18.6405 5.01385 18.8337 5.50008 18.8337H13.7501C14.2363 18.8337 14.7026 18.6405 15.0464 18.2967C15.3903 17.9529 15.5834 17.4866 15.5834 17.0003V16.0837'
          stroke='#ED0057'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M18.6862 6.53635C19.0473 6.17532 19.2501 5.68567 19.2501 5.1751C19.2501 4.66453 19.0473 4.17487 18.6862 3.81385C18.3252 3.45282 17.8356 3.25 17.325 3.25C16.8144 3.25 16.3248 3.45282 15.9638 3.81385L8.25 11.5001V14.2501H11L18.6862 6.53635Z'
          stroke='#ED0057'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M14.6667 5.08301L17.4167 7.83301'
          stroke='#ED0057'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </>
  )
}
